import {
  USERHISTORY_FAILURE,
  USERHISTORY_REQUEST,
  USERHISTORY_SUCCESS,
  USERHISTORY_BYID_REQUEST,
  USERHISTORY_BYID_SUCCESS,
  USERHISTORY_BYID_FAILURE,
} from "../types/userhistory.types";

const initialState = {
  storeItemResponse: "",
  storeItemByIdResponse: "",
  error: "",
  loading: false,
  loadingById: false,
};


const userHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case USERHISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USERHISTORY_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case USERHISTORY_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case USERHISTORY_BYID_REQUEST:
      return {
        ...state,
        loadingById: true,
      };
    case USERHISTORY_BYID_SUCCESS:
      return {
        ...state,
        storeItemByIdResponse: action.payload,
        loadingById: false,
      };
    case USERHISTORY_BYID_FAILURE:
      return {
        ...state,
        error: action.payload,
        loadingById: false,
      };
    default:
      return state;
  }
};

export default userHistoryReducer;